import { NgModule } from '@angular/core';
import { UserHeaderComponent } from './header';
import { IonicModule } from 'ionic-angular';
@NgModule({
  declarations: [UserHeaderComponent],
  imports: [IonicModule],
  exports: [UserHeaderComponent]
})
export class UserHeaderComponentModule { }



// WEBPACK FOOTER //
// ./src/components/header/header.module.ts